import { Exception, ExceptionCode } from "@konv/exceptions";

export class SaiposOrderChoiceItem {
	constructor({
		integration_code,
		desc_item_choice,
		aditional_price,
		quantity,
		notes
	}) {
		this.integration_code = integration_code;
		this.desc_item_choice = desc_item_choice;
		this.aditional_price = aditional_price;
		this.quantity = quantity;
		this.notes = notes;
	}

	static from(item) {
		const questions = item?.items || [];

		const choices = [];

		for (const question of questions) {
			const options = question?.items || [];
			for (const option of options) {
				const optionPrice = option.price || 0;
				const optionQuantity = option.quantity || 1;

				if (!option?.sku) {
					throw new Error(`O item ${item.name} - ${question.name} - ${option.name} está sem SKU`);
				}

				const childrenItem = new SaiposOrderChoiceItem({
					integration_code: option.sku,
					desc_item_choice: option.name,
					aditional_price: optionPrice,
					quantity: optionQuantity,
					notes: '',
				});

				choices.push(childrenItem);
			}
		}

		return choices;
	}
}
